import React, { useEffect, useState } from "react";

export default function GoogleMapsScriptProvider({ children }) {
  const [loaded, setLoaded] = useState(null);
  useEffect(() => {
    if (process.env.NODE_ENV !== "production") {
      setLoaded(true);
      return;
    }

    if (!window.google && loaded == null) {
      setLoaded(false);

      const script = document.createElement("script");
      script.type = "text/javascript";
      script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&libraries=places`;

      const headScript = document.getElementsByTagName("script")[0];
      headScript.parentNode.insertBefore(script, headScript);

      const onLoad = () => {
        script.removeEventListener("load", onLoad);
        setLoaded(true);
      };

      script.addEventListener("load", onLoad);

      // return () => script.removeEventListener("load", onLoad);
    }
  }, [loaded]);

  if (!loaded) {
    return <></>;
  } else {
    return <div>{children}</div>;
  }
}
